import { render, staticRenderFns } from "./ViewLogPage.vue?vue&type=template&id=cca707a4"
import script from "./ViewLogPage.vue?vue&type=script&lang=js"
export * from "./ViewLogPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports